

import './TestPage.css';

function TestPage() {
 //https://apps.apple.com/us/app/microsoft-authenticator/id983156458
 //https://play.google.com/store/apps/details?id=com.microsoft.appmanager&rdid=com.microsoft.appmanager
  const onClick = () => {
    window.open(
      'otpauth://totp/HealthSafe%20ID%3Adoneled521%3Adone-led%40gvh0rh0b.mailosaur.net?secret=KKMIOLJWFSM7LDDWZQZTAJO6GTYJI7GO&issuer=HealthSafe%20ID&algorithm=SHA1&digits=6&period=30',
      'totp',
      'left=20, top=20, toolbar=no, titlebar=yes, location=no, directories=no, status=no, menubar=no, resizable=1, scrollbars=yes',
    );
  }
  const onClick1 = () => {
    window.open(
      'msauthv2://totp/HealthSafe%20ID%3Adoneled521%3Adone-led%40gvh0rh0b.mailosaur.net?secret=KKMIOLJWFSM7LDDWZQZTAJO6GTYJI7GO&issuer=HealthSafe%20ID&algorithm=SHA1&digits=6&period=30',
      'totp',
      'left=20, top=20, toolbar=no, titlebar=yes, location=no, directories=no, status=no, menubar=no, resizable=1, scrollbars=yes',
    );
  }
  const onClick2 = () => {
    window.open(
      'msauthv2://HealthSafe ID:doneled521:done-led@gvh0rh0b.mailosaur.net?secret=KKMIOLJWFSM7LDDWZQZTAJO6GTYJI7GO&issuer=HealthSafe ID&algorithm=SHA1&digits=6&period=30',
      'totp',
      'left=20, top=20, toolbar=no, titlebar=yes, location=no, directories=no, status=no, menubar=no, resizable=1, scrollbars=yes',
    );
  }
 
  const onClick3 = () => {
    window.open(
      'msauthv2://identity.healthsafe-id.com?secret=KKMIOLJWFSM7LDDWZQZTAJO6GTYJI7GO&issuer=HealthSafe ID&algorithm=SHA1&digits=6&period=30',
      'totp',
      'left=20, top=20, toolbar=no, titlebar=yes, location=no, directories=no, status=no, menubar=no, resizable=1, scrollbars=yes',
    );
  }

  const onClick4 = () => {
    window.open(
      'otpauth://totp/identity.healthsafe-id.com?secret=KKMIOLJWFSM7LDDWZQZTAJO6GTYJI7GO&issuer=HealthSafe ID&algorithm=SHA1&digits=6&period=30',
      'totp',
      'left=20, top=20, toolbar=no, titlebar=yes, location=no, directories=no, status=no, menubar=no, resizable=1, scrollbars=yes',
    );
  }

  const onClick5 = () => {
    window.open(
      'msauthv2://totp/identity.healthsafe-id.com?secret=KKMIOLJWFSM7LDDWZQZTAJO6GTYJI7GO&issuer=HealthSafe%20ID&algorithm=SHA1&digits=6&period=30',
      'totp',
      'left=20, top=20, toolbar=no, titlebar=yes, location=no, directories=no, status=no, menubar=no, resizable=1, scrollbars=yes',
    );
  }

  const onClick6 = () => {
    window.open(
      'otpauth://totp/HealthSafe ID:mathewpauly:pauly.mathew@optum.com?secret=KKMIOLJWFSM7LDDWZQZTAJO6GTYJI7GO&issuer=HealthSafe ID',
      'totp',
      'left=20, top=20, toolbar=no, titlebar=yes, location=no, directories=no, status=no, menubar=no, resizable=1, scrollbars=yes',
    );
  }

  const onClick7 = () => {
    window.open(
      'otpauth://totp/dev@it.com?secret=123abc&issuer=StackOverflow',
      'totp',
      'left=20, top=20, toolbar=no, titlebar=yes, location=no, directories=no, status=no, menubar=no, resizable=1, scrollbars=yes',
    );
  }

  return (
    <div style={{ textAlign: 'center', margin: "50px" }}>
      <button style={{display: 'none'}} onClick={onClick}>Register authenticator otpauth://totp</button><br />
      <button style={{display: 'none'}} onClick={onClick1}>Register authenticator msauthv2://totp</button><br />
      <button style={{display: 'none'}} onClick={onClick2}>Register authenticator msauthv2://</button><br />
      <button style={{display: 'none'}} onClick={onClick3}>Register authenticator msauthv2://domain</button><br />
      <button style={{display: 'none'}} onClick={onClick4}>Register authenticator otpauth://totp/domain</button><br />
      <button style={{display: 'none'}} onClick={onClick5}>Register authenticator msauthv2://totp/domain</button><br />
      <button onClick={onClick6}>Register authenticator</button><br />
      <button style={{display: 'none'}} onClick={onClick7}>Register authenticator otpauth://totp demo</button><br />
    </div>
  );
}

export default TestPage;
